export const FETCH_LOGIN_PENDING = "FETCH_LOGIN_PENDING"
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS"
export const FETCH_LOGIN_ERROR = "FETCH_LOGIN_ERROR"
